<div class="loading__container">
  <div class="loading"></div>
</div>
